<template>
<div>
  <div class="footer">
    <div class="container main-container">
      <div class="footer-content">
        <h3><i><img src="../../../assets/images/icon1.png" /></i> 联系我们</h3>
        <p>邮箱：<a href="mailto:shbirghtclub@163.com">shbirghtclub@163.com</a></p>
        <p>地址：上海市青浦区沪青平公路6888号东方绿舟办公楼3楼</p>
        <p>邮编：201713</p>
      </div>
      <div class="qrcode">
        <dl>
          <dt><img src="../../../assets/images/code.png" width="120" height="120" /></dt>
          <dd>上海光明排球俱乐部微信公众号</dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="footer-copyright">
    Copyright 2022 <a href="http://www.shanghaivolleyball.com/">shanghaivolleyball.com</a> &nbsp; 上海市排球协会 &nbsp;
    <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022005273号-1</a>
  </div>
</div>
</template>
<script>
export default {
  name: 'XhFooter'
}
</script>
<style scoped>
.container {
  max-width: 1280px;
  margin: 0 auto;
}
.main-container {
  height: auto;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.footer {
  background-color: #282828;
  padding: 25px 32px 60px 32px;
}

.footer-content {
  font-size: 14px;
  color: #999;
  line-height: 28px;
}
.footer-content a {
  color: inherit;
}
.footer-content h3 {
  line-height: 36px;
  color: #fefefe;
}
.footer-content p {
  padding-left: 16px;
}
.footer .qrcode dl {
  padding-top: 12px;
  text-align: center;
  font-size: 16px;
  margin-left: 50px;
  color: #fff;
  display: block;
  float: left;
}
.footer .qrcode dl dd {
  padding-top: 18px;
}

.footer-copyright {
  font-size: 12px;
  color: #999;
  padding: 12px 0;
  line-height: 24px;
  text-align: center;
  background-color: #202020;
}
.footer-copyright a {
  color: #999;
}

@media screen and (max-width: 736px) {
.footer {
  background-color: #282828;
  padding: 24px 12px 30px 12px;
}

 .footer .qrcode {
   width: 240px;
 }
 .footer .qrcode dl dd {
    font-size: 12px;
    padding: 12px 0;
  }
  .footer .qrcode dl {
    margin-left: 32px;
  }
}
</style>
